module.exports = __webpack_public_path__ + "img/cross_red.eb43bf79.svg";